import React from 'react';
import Layout from '../../components/Layout';
import HeadMessage from '../../components/Common/HeadMessage/HeadMessage';
import Breadcrumbs from '../../components/Breadcrumbs';
import Widgets from './Widgets';
import { getPublicWidgets } from '../../data/widgets';
import { isHubReleased } from '../../data/widgets/release';
import {
	breadcrumbSchema,
	softwareApplicationSchema,
	SITE_URL,
} from '../../utils/seo';

/**
 * /widgets — хаб каталога виджетов.
 * Точка входа кластера: отсюда идёт перелинковка на все открытые лендинги.
 * Запрос — «widgets for chrome», 590 в месяц при сложности 2
 * (docs/seo/research/README.md, §4).
 */
function action() {
	// Хаб открывается вместе с первым лендингом: пустое оглавление
	// индексировать незачем. @see src/data/widgets/release.js
	if (!isHubReleased()) {
		return undefined;
	}

	// Только открытые: иначе ItemList уводит робота на страницы,
	// которые ещё не должны быть в индексе.
	const widgets = getPublicWidgets();

	return {
		title: 'Widgets for Chrome’s New Tab Page',
		description:
			'Widgets for Chrome’s new tab: countdowns, clocks, to-do lists, habit trackers, news and more. What each one does, how it’s set up, and what it can’t do.',
		chunks: ['widgets'],
		jsonLd: [
			softwareApplicationSchema({ withRating: true }),
			breadcrumbSchema([
				{ name: 'Home', url: '/' },
				{ name: 'Widgets', url: '/widgets' },
			]),
			{
				'@context': 'https://schema.org',
				'@type': 'ItemList',
				name: 'New Tab Studio widgets',
				numberOfItems: widgets.length,
				itemListElement: widgets.map((widget, i) => ({
					'@type': 'ListItem',
					position: i + 1,
					name: widget.name,
					url: `${SITE_URL}/widgets/${widget.slug}`,
				})),
			},
		],
		component: (
			<Layout>
				<Breadcrumbs
					items={[{ name: 'Home', url: '/' }, { name: 'Widgets' }]}
				/>

				<HeadMessage>
					<h1>
						Widgets for your Chrome <span>new tab</span>
					</h1>
					<h5>Everything you can drag onto the page, one by one</h5>
				</HeadMessage>

				<Widgets />
			</Layout>
		),
	};
}

export default action;
